import * as ShopifyCurrency from '@shopify/theme-currency';

import { COST_PER_ITEM_TAGS } from './const';

/**
 * Vue mixin for shared behaviour of the costPerItem computed property
 * This creates the (10$/capsule) text on purchase options
 */
export const costPerItemMixin = {
  computed: {
    currentCostPerItem() {
      if (
        !this.quantitySelector ||
        !this.quantitySelector.itemType ||
        !this.quantitySelector.translationKey
      ) {
        return false;
      }

      const costPerItem = this.currentPrice / this.quantitySelector.multiplier;

      return `(${ShopifyCurrency.formatMoney(costPerItem, this.moneyFormat)}/${
        this.translations[this.quantitySelector.translationKey]
      })`;
    }
  }
};

/**
 *
 * @param {array} tags Array of product tags
 * @param {function} cb Callback function
 * @returns {array}
 */
export function matchCostPerItemTag(tags, cb) {
  tags.forEach(tag => {
    Object.values(COST_PER_ITEM_TAGS).forEach(costPerItemTag => {
      if (tag.startsWith(costPerItemTag)) {
        const [matchedTag, matchedValue] = tag.split(':');
        cb([matchedTag, Number.parseInt(matchedValue)]);
      }
    });
  });
}

/**
 *
 * @param {array} selectedProducts Array of products
 * @returns {number}
 */
export const getTotalItems = selectedProducts => {
  return selectedProducts.reduce((totalItems, selectedProduct) => {
    let multiplier = 1;

    matchCostPerItemTag(selectedProduct.tags, ([, value]) => {
      multiplier = value;
    });

    totalItems += selectedProduct.quantity * multiplier;

    return totalItems;
  }, 0);
};

/**
 *
 * @param {array} tags Array of tags
 * @returns {}
 */
export const getCostPerItemDataFromTags = tags => {
  let itemType,
    multiplier = 1,
    translationKey;

  matchCostPerItemTag(tags, ([costPerItemTag, matchedValue]) => {
    itemType = costPerItemTag;
    multiplier = matchedValue;

    translationKey = costPerItemTag
      .replace('-per-box', '')
      .replace(/-./g, x => x.toUpperCase()[1]);
  });

  return {
    itemType,
    multiplier,
    translationKey
  };
};
